// ============================================================================
//  AJUDES DE TEXT DE PRODUCTE + VALORS DE FITXA TÈCNICA EN ALEMANY
//  Els noms/descripcions en alemany van dins de products.js (clau "de"),
//  igual que es/ca/en. Aquí només queden les traduccions dels VALORS de la
//  fitxa tècnica (les etiquetes ja es tradueixen soles).
// ============================================================================

const TECH_DE = {
  Reacondicionado: "Generalüberholt",
  Reconstruido: "Wiederaufgebaut",
  "12 meses": "12 Monate",
  "Cordierita / SiC": "Cordierit / SiC",
  "Catalizador de oxidación (DOC)": "Oxidationskatalysator (DOC)",
  "Catalizador + DPF integrado": "Katalysator + integrierter DPF",
  "EATU (postratamiento) con DPF": "EATU (Abgasnachbehandlung) mit DPF",
};

// Text d'un producte en l'idioma actiu; si falta, cau al castellà
export const pText = (product, lang, field) =>
  product[field]?.[lang] || product[field]?.es || "";

// Valor de fitxa tècnica traduït a l'alemany si hi consta
export const techText = (lang, value) =>
  (lang === "de" && TECH_DE[value]) || value;
